import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-753deeb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "virtual" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "square_container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "square_meta" }
const _hoisted_8 = { class: "square_meta_title" }

import axios from '@/api/control/virtual';
import { getAlias, removeToken } from '@/plugins/cookie';
import { ref, reactive, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import CLoadingVue from '@/components/CLoading.vue';
import { message } from 'ant-design-vue';

interface VirtualInfo {
  configure: string;
  cover_url: string;
  scene_id: string;
  scene_name: string;
  scene_url: string;
  status: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Virtual',
  setup(__props) {

const { proxy }: any = getCurrentInstance();
const route = useRoute();
const router = useRouter();
const studioId = route.params.studioId;

const list = ref<VirtualInfo[]>([]);

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 25, // 每页条数
  totalSize: 0, // 总页数
});
const loading = ref(false);

// 获取列表
const getList = () => {
  loading.value = true;
  axios
    .getSceneList({ params: { studio_id: studioId } })
    .then((res) => {
      list.value = res.data.data;
    })
    .finally(() => (loading.value = false));
};

getList();

const scrollList = () => {
  if (pageConfig.totalSize && list.value.length < pageConfig.totalSize) {
    //
  }
};

// 获取token
const token = ref();
const getToken = async () => {
  try {
    const res = await axios.getTokenInfo({ params: { alias: getAlias() } });
    token.value = res.data.data.token;
  } catch (err) {
    console.error(err);
  }
};
getToken();
const alias = ref();
alias.value = localStorage.getItem('alias');
const toVirtual = (item: VirtualInfo) => {
  const url = proxy.$virtualLink;
  // 111
  const href = url + '?sceneId=' + item.scene_id + '&token=' + token.value + '&studio_id=' + studioId;
  if (token.value) {
    window.open(href);
  } else {
    message.info('请重新登陆！');
    removeToken();
    // router.replace('Login');
    const subAlias = localStorage.getItem('sub_logo');
    router.push(`/${subAlias}/sub_login`);
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "square",
              onClick: ($event: any) => (toVirtual(item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.cover_url,
                  alt: ""
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.scene_name), 1)
              ])
            ], 8, _hoisted_4)
          ]))
        }), 128))
      ]),
      (loading.value)
        ? (_openBlock(), _createBlock(CLoadingVue, {
            key: 0,
            class: "loading"
          }))
        : _createCommentVNode("", true)
    ])), [
      [_directive_infinite_scroll, scrollList]
    ])
  ]))
}
}

})